module.exports = __webpack_public_path__ + "static/media/midnight-lines-right.8bfed95c.png";